import React from "react"
import { IQuestion, ELanguage } from "../../../models"
import PunchQuestionItemAnswerHTMLViewer from "./PunchQuestionItemAnswerHTMLViewer"
interface IProps {
    questions: IQuestion[]
    btn1Ids: string[]
    btn2Ids: string[]
}

const PunchQuestionAnswerViewer: React.SFC<IProps> = (props: IProps) => {
    const btnIds = (props.btn1Ids || []).concat(props.btn2Ids || [])
    if (btnIds.length === 0) return null
    const firstQuestion = props.questions.find(i => i.GUId === btnIds[0])
    if (!firstQuestion) return null
    const isPunchIn = firstQuestion.PunchIn
    const questions = props.questions.filter(i => i.PunchIn === isPunchIn && i.Language === ELanguage.English)
    return (
        <div>
            {questions.filter(i => !i.Child).map((question, index) =>
                <div key={index} style={{ marginBottom: 10 }}>
                    <PunchQuestionItemAnswerHTMLViewer
                        question={question}
                        questions={props.questions.filter(i => i.PunchIn === isPunchIn)}
                        btn1Ids={props.btn1Ids}
                        btn2Ids={props.btn2Ids}
                    />
                    <PunchChildQuestionAnswerViewer
                        level={0}
                        rootQuestion={question}
                        questions={props.questions.filter(i => i.PunchIn === isPunchIn)}
                        btn1Ids={props.btn1Ids}
                        btn2Ids={props.btn2Ids}
                    />
                </div>
            )}
        </div>
    )
}
export default PunchQuestionAnswerViewer

interface IChildQuestionProps {
    level: number
    rootQuestion: IQuestion
    questions: IQuestion[]
    btn1Ids: string[]
    btn2Ids: string[]
}
const PunchChildQuestionAnswerViewer: React.SFC<IChildQuestionProps> = (props: IChildQuestionProps) => {
    const btn1Clicked = (props.btn1Ids || []).find(i => props.questions.filter(e => e.GroupId === props.rootQuestion.GroupId).find(e => e.GUId === i)) !== undefined
    const btn2Clicked = (props.btn2Ids || []).find(i => props.questions.filter(e => e.GroupId === props.rootQuestion.GroupId).find(e => e.GUId === i)) !== undefined
    return (
        <div style={{ marginLeft: props.level > 0 && 40, marginTop: 5 }} className="aaaa">
            {props.level > 0 &&
                <PunchQuestionItemAnswerHTMLViewer
                    question={props.rootQuestion}
                    questions={props.questions}
                    btn1Ids={props.btn1Ids}
                    btn2Ids={props.btn2Ids}
                />
            }
            {btn1Clicked && props.rootQuestion.Btn1Action >= 0 &&
                <PunchChildQuestionAnswerViewer
                    level={props.level + 1}
                    rootQuestion={props.questions.find(i => i.GroupId === props.rootQuestion.Btn1Action && i.Language === ELanguage.English)}
                    questions={props.questions}
                    btn1Ids={props.btn1Ids}
                    btn2Ids={props.btn2Ids}
                />
            }
            {btn2Clicked && props.rootQuestion.Btn2Action >= 0 &&
                <PunchChildQuestionAnswerViewer
                    level={props.level + 1}
                    rootQuestion={props.questions.find(i => i.GroupId === props.rootQuestion.Btn2Action && i.Language === ELanguage.English)}
                    questions={props.questions}
                    btn1Ids={props.btn1Ids}
                    btn2Ids={props.btn2Ids}
                />
            }
        </div>
    )
}

